import { render, staticRenderFns } from "./FormAddress.vue?vue&type=template&id=70b2b4f1&scoped=true"
import script from "./FormAddress.vue?vue&type=script&lang=js"
export * from "./FormAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b2b4f1",
  null
  
)

export default component.exports